import { Box } from '@mui/material';
import { theme } from '../../theme';

export const Section = (props: { children: React.ReactNode }) => {
  return (
    <Box sx={{
      border: '1px solid',
      boxShadow: '0 1px 2px 1px #1018280D',
      borderRadius: '12px',
      borderColor: theme.palette.custom.gray[300],
    }}>
      {props.children}
    </Box >
  );
};

